import { render, staticRenderFns } from "./ProgramacionRegaliasForm.vue?vue&type=template&id=06208608"
import script from "./ProgramacionRegaliasForm.vue?vue&type=script&lang=js"
export * from "./ProgramacionRegaliasForm.vue?vue&type=script&lang=js"
import style0 from "./ProgramacionRegaliasForm.vue?vue&type=style&index=0&id=06208608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports